import {Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewContainerRef} from "@angular/core";
import {PusherService} from "./core/visbos-core/subscriptions/pusher.service";
import {Subscription} from "rxjs/Subscription";
import {Router} from "@angular/router";
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {UserService} from "./crm/user/user.service";
import {SessionActions} from "./shared/actions";
import {NgRedux, select} from "@angular-redux/store";
import {Observable} from "rxjs/Observable";
import {IAppState} from "./shared/redux-store";

@Component({
  selector: 'visbos-root',
  templateUrl: './visbos.component.html',
  styleUrls: ['./visbos.component.css'],
})
export class VisBosComponent implements OnInit, OnDestroy {

  @select(['session', 'loggedIn'])
  loggedIn$: Observable<boolean>;

  private loggedInSub: Subscription;

  title = 'VisBOS by witcotech';

  private maintenanceChannelSub: Subscription;
  private modalRef: BsModalRef;

  maintenanceStartTime: Date;

  @ViewChild('maintenanceModalTmpl')
  maintenanceModalTmpl: TemplateRef<any>;

  constructor(public rootViewRef: ViewContainerRef, private pusherService: PusherService,
              private router: Router, private modalService: BsModalService,
              private userService: UserService, private sessionActions: SessionActions,
              private ngRx: NgRedux<IAppState>) {
    this.bindMaintenanceChannel();
  }

  ngOnInit(): void {
    this.loggedInSub = this.loggedIn$.subscribe(loggedIn => {
      if (loggedIn) {
        this.sessionActions.fetchAuthorizedUser().toPromise();
      }
    })
  }

  openModal(template: TemplateRef<any>) {
    const config = {
      animated: true,
      keyboard: true,
      backdrop: true,
      ignoreBackdropClick: true
    };
    this.modalRef = this.modalService.show(template, config);
  }

  private bindMaintenanceChannel() {
    this.maintenanceChannelSub = this.pusherService.maintenanceChannel$.subscribe(channel => {
      if (channel) {
        console.info("Binding to maintenance channel...");

        channel.bind('maintenance.warning', (event) => {
          console.info("Received warning event on maintenance channel: ", event);
          this.openModal(this.maintenanceModalTmpl);
          this.maintenanceStartTime = new Date(event.maintenanceTime);
        });

        channel.bind('maintenance.start', (event) => {
          console.info("Received start event on maintenance channel: ", event);
          this.maintenanceStartTime = null;
          if (this.modalRef) {
            this.modalRef.hide();
          }
          this.router.navigate(['maintenance']);
        });

        channel.bind('maintenance.finished', (event) => {
          console.info("Received finish event on maintenance channel: ", event);
          this.maintenanceStartTime = null;
          if (this.modalRef) {
            this.modalRef.hide();
          }
          this.router.navigate(['/'])
            .then(res => window.location.reload(true))
            .catch(err => window.location.reload(true));

        });

      }
    });
  }

  ngOnDestroy(): void {
    if (this.loggedInSub) {
      this.loggedInSub.unsubscribe();
    }
    if (this.maintenanceChannelSub) {
      this.maintenanceChannelSub.unsubscribe();
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/visbos.component.ts